diy.angular.registerDirective('diyfmsections', ['$timeout', 'diysqueezebox', 'diyfmselectiondata', 'diyappevents',
function($timeout, diysqueezebox, diyfmselectiondata, diyappevents) {

    var tpl = '\
        <div class="fm-category-menu" data-diyfmmenu="" ng-model="menuConfig"></div>\
        <div class="fm-folders-list">\
            <div class="fm-token-wrapper">\
                <div ng-repeat="section in sections.getSections()" data-section-id="{{section.id}}">\
                    <div class="diye-collapsible-category-header"\
                        ng-click="sectionClicked(section)"\
                        ng-class="{\'current\': section === sections.getCurrentSection()}">\
                        <div class="diye-collapsible-category-positioned">\
                            <div class="diye-collapsible-category-title">\
                                <!-- use ng-bind-html because we don\'t want to double escape here -->\
                                <span ng-bind-html="section.getTitle()"></span>\
                            </div>\
                            <div class="fm-category-actions">\
                                <button ng-repeat="_action in section.getActions()"\
                                    class="ui-button-borderless "\
                                    diybutton="{\'icons\':{\'primary\':\'{{_action.icon}}\'}, \'text\': false}"\
                                    ng-click="_action.handler($event, section);"\
                                    title="{{_action.title}}"\
                                ></button>\
                            </div>\
                            <div class="diye-collapsible-category-pointer"></div>\
                            <div class="diye-collapsible-category-arrow"></div>\
                        </div>\
                    </div>\
                    \
                    <div class="diye-collapsible-category-content div-additional-content">\
                        <ul>\
                            <li\
                                ng-repeat="subsection in section.getSubsections()"\
                                ng-class="{\'fm-subsection-current\': subsection === sections.getCurrentSubsection()}"\
                                ng-click="subsectionClicked(subsection);"\
                            >\
                                <div data-diyfmsection="" \
                                    ng-model="subsection"\
                                    open-menu="openMenu(menuConfig)"\
                                    >\
                                </div>\
                            </li>\
                        </ul>\
                    </div>\
                    <div class="clear"></div>\
                </div>\
            </div>\
        </div>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {

            scope.openMenu = function(menuConfig) {
                scope.menuConfig = menuConfig;
            };
            
            var doSubsectionAutoscroll = true;
            
            scope.subsectionClicked = function(subsection) {
                doSubsectionAutoscroll = false;
                scope.sections.setCurrentSubsection(subsection);
                $timeout(function(){doSubsectionAutoscroll = true});
            };
            
            scope.sectionClicked = function(section) {
                doSubsectionAutoscroll = false;
                scope.sections.setCurrentSection(section);
                $timeout(function(){doSubsectionAutoscroll = true});
            };
            
            var squeeseBoxEl = jQuery('.fm-folders-list', elem);
            
            diysqueezebox.initialize(squeeseBoxEl, {
                clickToOpen: true,
                fixableSelector: '.diye-collapsible-category-header',
                fixedClassName: 'fixed',
                activeClassName: 'active'
            });
            
            var scrollToCurrent = function() {
                diysqueezebox.refresh(squeeseBoxEl);
                diysqueezebox.scrollToItem(
                    squeeseBoxEl,
                    jQuery('.fm-subsection-current', elem),
                    null, 0 /*instant scroll, no animations*/
                );
            };
            
            scope.$watch('sections.getCurrentSubsection()', function(newSubsection, oldSubsection) {
                if (doSubsectionAutoscroll && newSubsection) {
                    // timeout to let it render the change
                    $timeout(function(){
                        scrollToCurrent();
                    });
                }
            });
            
            diyappevents.bind('subSectionsLoaded', function(){
                // timeout to let it render the change
                $timeout(function(){
                    scrollToCurrent();
                });
            });

            var getSubsectionByElement = function(el) {
                return angular.element(el).scope().subsection;
            };

            var removeDragDropHover = function() {
                jQuery('[data-section-id] ul > li').removeClass('fm-subsection-dragover');
            };

            var canMoveItemsInDragging = function() {
                return diyfmselectiondata.getSelectedItems().every(function(item) { return item.canMove(); });
            };

            jQuery(elem).delegate('li', 'dragover', function(ev) {
                /* if there's no preventDefault in the dragover event,
                 then no drop will occur. highly undocumented featured,
                 found this out on StackOverflow */
                ev.preventDefault();
            });

            jQuery(elem).delegate('li', 'dragover', function(ev) {
                removeDragDropHover();
                var subsection = getSubsectionByElement(this);
                if (subsection.canMoveTo() && canMoveItemsInDragging()) {
                    jQuery(this).addClass('fm-subsection-dragover');
                }
            });

            jQuery(elem).bind('dragleave', function(ev) {
                removeDragDropHover();
            });

            jQuery(elem).delegate('li', 'drop', function(ev) {
                removeDragDropHover();

                /* get destination and source subsection */
                var destinationSubsection = getSubsectionByElement(this);
                
                if (ev.originalEvent.dataTransfer
                    && ev.originalEvent.dataTransfer.files
                    && ev.originalEvent.dataTransfer.files.length > 0)
                {
                    scope.$emit('uploadFiles.up', ev.originalEvent.dataTransfer.files, destinationSubsection, false, 'drag-sections');
                } else {
                    var sourceSubsection = scope.sections.getCurrentSubsection();
                    
                    /* if destination subsection does not support moving into, don't drop */
                    if (!destinationSubsection.canMoveTo()) {
                        return false;
                    }

                    // if items cannot be moved into the section, don't drop
                    if (!canMoveItemsInDragging()) {
                        return false;
                    }
                    
                    /* can't drag and drop over itself */
                    if (destinationSubsection === sourceSubsection) {
                        return true;
                    }
                    
                    /* get items to move */
                    var moveItems = diyfmselectiondata.getSelectedItems();
                    
                    scope.$apply(function(scope) {
                        /* move the items */
                        sourceSubsection.moveItems(moveItems, destinationSubsection);
                        
                        /* deselect the moved items */
                        diyfmselectiondata.removeAllItems(['select']);
                    });
                    
                }
                return false;
            });
            
            scope.$on('$destroy', function(){
                diyappevents.unbind('subSectionsLoaded');
            });
        }
    };

}]);




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmsections.js
 ** module id = 972
 ** module chunks = 0
 **/